import { useEffect, useState } from "react";
import { getAssetApi, getConstantApi, getCurrencyApi, getEngineLLPApi, getEngineThrustApi, getMaintenanceEventApi,  reserveRatesAttachmentMetaData, reserveRatesfileUploadPostApi } from "../apiService";
import { getAccountTypeListApi } from "../../settings/AccountType/apiService";
import { globalPostService, globalGetService, globalPostFileUploadService, globalPostFileUpdateService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { useSnackbar } from "notistack";
import { assetType } from "../../../constants";
import UploadProgressSnackbar from "../../../shared_elements/components/UploadProgressSnackbar";

const useGetApiHook = (params, modeType, updatedReserveData, toggleLoader) => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [pltConstants, setPltConstants] = useState({ constant_types: [], asset_types: [], thrust:[], asset:[], rate_account_types: [],lg_asset_types : [] });
    const [dropDownLoader,setDropDownLoader]=useState({currency:false,account_type:false,major_assembly:false,reserve_rate_interval:false,maintenance_events:false,thrust:false, rate_account_type: false})
    const [filteredIntervalData, setFilteredIntervalData] = useState([]);
    const [filteredIntervalList, setFilteredIntervalList] = useState([]);
    const getOptionForInterval = (rateType, assetType, intervalArr) => {
        let intervalData = (intervalArr?.length && intervalArr?.filter(item => item.type === 'interval')) || []
        let filtered = [];
        if (rateType?.value === 1) { filtered = intervalData?.filter(item => assetType === 1 ? [1, 2, 3, 5, 6].includes(item.value) : [1, 2, 3, 5].includes(item.value)); }
        else if (rateType?.value === 2) { filtered = intervalData?.filter(item => assetType === 1 ? [2, 3, 4, 6].includes(item.value) : [2, 3, 4].includes(item.value)); }
        else if (rateType?.value === 3) { filtered = intervalData?.filter(item => assetType === 2 ? [ 8, 9, 10, 11].includes(item.value) : [ 8, 9].includes(item.value)); }
        setFilteredIntervalData(filtered)
        let updatedFilter = [];
        if (rateType?.value === 3) { updatedFilter = intervalData?.filter(item => [2, 3].includes(item.value)); }
        setFilteredIntervalList(updatedFilter)
    }
 
    const getPltConstants = () => {
        setDropDownLoader(prev => ({ ...prev, account_type: true }));
        globalPostService(getConstantApi(), { constant_types: ['reserve_account_type', "reserve_rate_type", 'interval', "thrust_category", "round_off_escalation", "escalation_interval", "mr_rate_range_condition", "rental_rate_type", "claim_type", "claim_event_type"] })
            .then(response => {
            setDropDownLoader(prev => ({ ...prev, account_type: false }));
                if (checkApiStatus(response)) {
                    setPltConstants(prevConstants => ({
                        ...prevConstants,
                        constant_types: response.data.data || [],
                    }));
                    if (modeType === "edit") {
                        getOptionForInterval(updatedReserveData?.data?.reserve_rate_type, updatedReserveData?.data?.major_assembly?.asset_type, response?.data?.data)
                    }
                }
            })
    }

    const getMaintenanceEvent = (assetData) => {
        setDropDownLoader(prev => ({ ...prev, maintenance_events: true }));
        globalGetService(
            getMaintenanceEventApi(assetType[assetData?.asset_type], assetData?.asset_id ? assetData?.asset_id :assetData?.id))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, maintenance_events: false }));
                if (checkApiStatus(response)) { 
                    const maintenanceEvents = response?.data?.data[0]?.maintenance_events;
                    const updatedMaintenanceEvents = Array.isArray(maintenanceEvents) ? maintenanceEvents : (response?.data?.data || []);
                    setPltConstants(prevConstants => ({ ...prevConstants, maintenance_events: updatedMaintenanceEvents || [], })); }
            })
    }
    const getCurrency = () => {
        setDropDownLoader(prev => ({ ...prev, currency: true }));
        globalGetService(
            getCurrencyApi())
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, currency: false }));
                if (checkApiStatus(response)) { 
                    setPltConstants(prevConstants => ({ ...prevConstants, currencies: response?.data?.data || [], })); }
            })
    }
    const getRateAccountTypes = () => {
        setDropDownLoader(prev => ({ ...prev, rate_account_type: true }));
        globalGetService(getAccountTypeListApi({ lite: true, applicable_for: 2 }))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, rate_account_type: false }));
                if (checkApiStatus(response)) {
                    const list = response?.data?.data?.list || [];
                    setPltConstants(prev => ({
                        ...prev,
                        rate_account_types: list
                    }));
                }
            });
    }

    const getAssetDropDown = (value) => {

        setDropDownLoader(prev => ({ ...prev, asset: true }));

        globalGetService(getAssetApi(value))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, asset: false }));

                if (checkApiStatus(response)) {
                    const assetData = response?.data?.data || [];

                    setPltConstants(prev => ({
                        ...prev,
                        asset: assetData
                    }));

                    const engineTypeId = assetData?.[0]?.engine_type_id;
                    getEngineThrust(engineTypeId);
                }
            });
    }

    const getEngineThrust = (engineTypeId) => {
        if (!engineTypeId) return;

        setDropDownLoader(prev => ({ ...prev, thrust: true }));
        globalGetService(getEngineThrustApi(engineTypeId))
            .then(response => {
                setDropDownLoader(prev => ({ ...prev, thrust: false }));
                if (checkApiStatus(response)) {
                    setPltConstants(prev => ({
                        ...prev,
                        thrust: response?.data?.data || []
                    }));
                }
            });
    }

    const getEngineLLPs = async(assetType, assetSlug, query) => {
        toggleLoader("skeletonLoader", true)
        return globalGetService(getEngineLLPApi(assetType, assetSlug, query))
            .then(response => {
                if (checkApiStatus(response)) {
                    toggleLoader("skeletonLoader", false)
                    if (query === "module") {
                        const data = response?.data?.data;
                        const llpItems = (data?.llp ?? []).map((ele, index) => ({
                            module_name: ele,
                            fund_allocation_percentage: 0,
                            id: `llp_${ele}_${index}`,
                        }));
                        const nonLlpItems = (data?.non_llp ?? []).map((ele, index) => ({
                            module_name: ele,
                            fund_allocation_percentage: 0,
                            id: `non_llp_${ele}_${index}`,
                            is_non_llp: true,
                        }));
                        return [...llpItems, ...nonLlpItems];
                    } else {
                        const data = response?.data?.data;
                        const processGroup = (groupData, isNonLlp) => {
                            const seen = {};
                            const cleanedData = {};
                            Object.keys(groupData ?? {}).forEach(module => {
                                const uniqueParts = [];
                                groupData[module]?.forEach(part => {
                                    if (!seen[part]) {
                                        seen[part] = true;
                                        uniqueParts.push(part);
                                    }
                                });
                                cleanedData[module] = uniqueParts;
                            });
                            const prefix = isNonLlp ? 'non_llp' : 'llp';
                            return Object.entries(cleanedData).flatMap(([module, descriptions]) =>
                                descriptions.map((description, index) => ({
                                    module_name: module,
                                    id: `${prefix}_${module}_${index}`,
                                    description,
                                    ...(isNonLlp ? { is_non_llp: true } : {}),
                                }))
                            );
                        };
                        return [
                            ...processGroup(data?.llp, false),
                            ...processGroup(data?.non_llp, true),
                        ];
                    }
                } else {
                    enqueueSnackbar(response?.data?.message, { variant: "error",hideIconVariant:true, anchorOrigin: { vertical: "top", horizontal: "right" }, })
                    toggleLoader("skeletonLoader", false)
                }
                return [];
            });
    };
    
    const uploadFiles = (lease_slug ,attachedFiles, getResponseBack) => {
     if (!attachedFiles?.length) return;

        const payload = {
      files: attachedFiles.map(file => ({
      file_name: file.name,
      file_size: file.size,
      file_type: file.name.split(".").pop().toLowerCase()
      }))
    };
     toggleLoader("pageLoader", true);
      const progressRefs = { current: [] };

     globalPostFileUploadService(reserveRatesfileUploadPostApi(lease_slug), payload)
     .then((response) => {
      const filesData = response?.data?.data?.files;
      if (checkApiStatus(response) && Array.isArray(filesData)) {
        const snackbarKey = enqueueSnackbar(
          <UploadProgressSnackbar
            progressRefs={progressRefs}
            attachments={attachedFiles}
          />,
          {
            persist: true,
            variant: "info",
            anchorOrigin: { vertical: "bottom", horizontal: "left" }
          }
        );
        const uploadPromises = filesData.map((fileData, index) => {
          const file = attachedFiles[index];
          return globalPostFileUpdateService(fileData.pre_signed_url, file, (p) => {
            if (progressRefs.current[index]) progressRefs.current[index](p);
          })
          .then(() => {
            return globalPostFileUploadService(
              reserveRatesAttachmentMetaData(fileData.attachment_slug),
              { attachment_slug: fileData.attachment_slug, status: { value: 1 } }
            );
          });
        });
        Promise.all(uploadPromises)
          .then(() => {
           toggleLoader("pageLoader", false);
            closeSnackbar(snackbarKey);
            enqueueSnackbar(
              attachedFiles.length === 1
                ? "Your file has been uploaded"
                : "Your files have been uploaded",
              { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
            );

            getResponseBack();
          })
          .catch((err) => {
            console.error(err);
            enqueueSnackbar("Error while uploading files", { variant: "error" });
            toggleLoader("pageLoader", false);
          });

      } else {
        toggleLoader("pageLoader", false);
        enqueueSnackbar(response?.data?.message, { variant: "error" });
      }
     });
    };

    useEffect(() => {
        if (modeType === "edit") {getMaintenanceEvent(updatedReserveData?.data?.major_assembly); if(updatedReserveData?.data?.major_assembly?.asset_type===2) getAssetDropDown(updatedReserveData?.data?.major_assembly?.asset_slug) }
        getPltConstants()
        getCurrency()
        getRateAccountTypes()
        getEngineThrust()
    }, [])
    return { pltConstants,setPltConstants,setDropDownLoader, filteredIntervalData,filteredIntervalList,dropDownLoader, getOptionForInterval, getMaintenanceEvent,getCurrency, getEngineLLPs, uploadFiles , getEngineThrust, getAssetDropDown}
}

export default useGetApiHook